module.exports = __webpack_public_path__ + "static/media/forsaga.30968c04.mp3";